// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Layout Grid Cell */
:host(.editable),
.editable {
  position: relative;
  border: 1px solid var(--ids-color-palette-blue-20);
}

::slotted(.close-btn),
.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-layout-grid/ids-layout-grid-cell.scss"],"names":[],"mappings":"AAAA,yBAAA;AACA;;EAEE,kBAAA;EACA,kDAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,UAAA;EACA,YAAA;AACF","sourcesContent":["/* Ids Layout Grid Cell */\n:host(.editable),\n.editable {\n  position: relative;\n  border: 1px solid var(--ids-color-palette-blue-20);\n}\n\n::slotted(.close-btn),\n.close-btn {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
